import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger';

interface IRequestParams {
  phone: string;
}

interface IResponseParams {
  uuid?: string;
  error?: string;
}

export const fetchPhone = async (
  { httpApi, logger }: { httpApi: IHttpApi; logger: ILogger },
  parameters: IRequestParams,
) => {
  try {
    const response: IResponseParams = await postPhoneNumber(httpApi, parameters);

    return response;
  } catch (error) {
    logger.error(error, {
      domain: 'fetchPhone',
    });

    return { error: 'Возникла ошибка при регистрации телефона' };
  }
};

export async function postPhoneNumber(httpApi: IHttpApi, params: IRequestParams) {
  const { responseBody } = await httpApi.httpRequest({
    method: 'POST',
    headers: [
      ['Accept', 'application/json'],
      ['Content-Type', 'application/json'],
    ],
    body: JSON.stringify(params),
    uri: {
      scheme: 'https',
      host: 'fin.cian.ru',
      path: '/authorization-service/phone',
    },
    withCredentials: true,
  });

  const result: IResponseParams = JSON.parse(responseBody);

  return result;
}
